export const isPaidPlan = (userdb) => {
	if (!userdb) return false;
	const nickname = userdb.stripe_plan?.nickname || '';
	const active = userdb.stripe_plan?.active;
	const status = userdb.stripe_status;
	if (!active) return false;
	if (status === 'deleted' || status === 'past_due') return false;
	return /Visionary|Oracle|Apprentice/i.test(nickname);
};
